import {Component, ViewChild} from "@angular/core";
import {NavParams, Events, PopoverController, Content, Platform, NavController, Navbar} from "ionic-angular";
import {JobService} from "./shared/job.service";
import {Job} from "./shared/job.model";
import {RoleService} from "../../app/core/role.service";
import {JobMenuComponent} from "./job-menu/job-menu.component";
import {JobControlsService} from "./job-controls/job-controls.service";
import {JobMenuService} from "./job-menu/job-menu.service";

@Component({
  templateUrl: 'job.page.html',
})
export class JobPage {
  @ViewChild(Content) content: Content;
  @ViewChild(Navbar) navBar: Navbar;

  job: Job;
  routeParams = {id: null};
  view: string = 'details';
  role: string;
  roleSub: any;
  hasButtons: boolean = null;
  restoreBackButtonAction = null;

  constructor(private navParams: NavParams,
              private jobService: JobService,
              private events: Events,
              private roleService: RoleService,
              private popoverCtrl: PopoverController,
              private jobControlsService: JobControlsService,
              private jobMenuService: JobMenuService,
              private platform: Platform,
              private nav: NavController
  ) {
  }

  private getJob(onDone?) {
    this.jobService.getJob(this.routeParams.id)
      .subscribe((data) => {
        this.job = new Job(data);
        if (onDone) {
          onDone();
        }
      });
  }

  ionViewWillEnter() {
    this.routeParams = {id: this.navParams.get('id')};
    if(this.routeParams.id){
      this.getJob(() => this.jobService.startWatchingIfJobDone(this.job));
    }else{
      this.job = new Job();
      this.job.edit();
    }

    this.roleSub = this.roleService.getRole()
      .subscribe((role) => this.role = role);

    this.events.subscribe('job:updated', () => this.getJob());

    this.navBar.backButtonClick = () => this.backButtonAction();
    this.restoreBackButtonAction = this.platform.registerBackButtonAction(() => this.backButtonAction(), 10);
  }

  ionViewWillLeave() {
    this.roleSub.unsubscribe();

    this.events.unsubscribe('job:updated');
    this.jobService.stopWatchingIfJobDone();

    this.restoreBackButtonAction && this.restoreBackButtonAction();
  }

  backButtonAction(){
    // TODO: refactor edit view and detailed view into seperate pages
    if(this.job && !this.job.editMode && this.job.edited){
      return this.job.edit();
    }
    return this.nav.pop();
  }

  openJobMenu(event){
    let menu = this.popoverCtrl.create(JobMenuComponent, {
      job: this.job
    });
    menu.present({
      ev: event,
    });
  }

  hasFooterButtons(){
    let hasButtons = this.jobControlsService.hasButtons(this.job, this.role);
    if(hasButtons !== this.hasButtons){
      this.content.resize();
      this.hasButtons = hasButtons;
    }
    return hasButtons;
  }

  hasMenu(){
    return this.jobMenuService.hasButtons(this.job, this.role) && this.job && !this.job.editMode;
  }
}



// WEBPACK FOOTER //
// ./src/pages/job/job.page.ts